const LOCAL_STORAGE_KEY = 'FL4b775d0c1413e77e23b2ac387cb0b65f50fcf0fcd0cc85c205ed77d04bc9d232'

export const API_URL = process.env.REACT_APP_API_URL

export const DOCS_URL = process.env.REACT_APP_DOCS_URL

export const request = async (url, method = 'GET', body) => {
    const { token } = getInfoLocalStorage();
    const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }
    if (token) {
        headers.Authorization = `Bearer ${token}`
    }
    const response = await fetch(API_URL + url, {
        method,
        headers,
        body: body === undefined ? undefined : JSON.stringify(body)
    })
    const result = await response.json()
    return result
}

export const getInfoLocalStorage = () => (
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || {}
)

export const setInfoLocalStorage = (data) => {
    const infoFromLocalStorage = getInfoLocalStorage()
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({
        ...infoFromLocalStorage,
        ...data
    }))
}

export const destroyInfoLocalStorage = () => (
    localStorage.removeItem(LOCAL_STORAGE_KEY)
)

export const removeFromLocalStorage = (param) => {
    for(var i = 0; i < localStorage.length; i++) {
        let key = localStorage.key(i)
        if(localStorage.getItem(key) === param) {
            localStorage.removeItem(key)
        }
    }
}